import React from 'react'
import {Header, Label} from 'semantic-ui-react'
import moment from 'moment';
function ModalHeader(props) {
    const {modalType,modalContractType,startDate,doctorName, providerCustomRates,modalWithHyn} = props;
    let modalTitle='';
    if(modalType==='collectionsBillableCare'){
        modalTitle= modalContractType +' '+"List";
    }else if(modalType==='tedCollections'){
        modalTitle= "TED Collections List ("+ moment(startDate).format('MMMM YYYY') +")";
    }else if(modalType==='earnings'){
        modalTitle= "CDP Dentist's Pre-Tax Earning's Summary ("+modalContractType+ (modalWithHyn?" w/Hyn bcare":"")+")";
    } else if(modalType==='billableCare'){
        modalTitle = " MTD Billable Care"+" ("+ moment(startDate).format('MMMM YYYY') +")"
    } else if(modalType==="goxBillableCare"){
        modalTitle = doctorName+ " X-Ray " + modalContractType +" ("+ moment(startDate).format('MMMM YYYY') +")";
    }

    return (
        <Header>
            {modalTitle}
            {providerCustomRates && providerCustomRates.length > 0 && <Label as='a' color='teal'>
                Custom Rates
            </Label>}
        </Header>
    )
}


export  default ModalHeader